<template>
    <div class="columns is-centered">
        <div class="column" v-if="initDone">
            <div v-if="paymentGatewayConfigs.length > 0">
                <div class="field">
                    <label class="label">{{ translate("pricing.choose_existing_config") }}</label>
                    <div class="control is-expanded">
                        <div class="select is-fullwidth">
                            <select v-model="selectedExistingConfigurationId">
                                <option value="0">---</option>
                                <option
                                    :value="paymentGatewayConfig.id"
                                    v-for="paymentGatewayConfig in paymentGatewayConfigs"
                                    :key="paymentGatewayConfig.id"
                                >
                                    [{{ paymentGatewayConfig.provider }}] {{ paymentGatewayConfig.name }}
                                </option>
                            </select>
                        </div>
                    </div>
                </div>
                <div class="field">
                    <div class="control">
                        <button class="button" @click="confirmExistingConfiguration" :disabled="!canChooseExistingConfig">
                            <span class="icon"> <i class="fas fa-check"></i></span>
                            <span>{{ translate("common.choose") }}</span>
                        </button>
                    </div>
                </div>
            </div>
            <div v-else>
                <Notification class="is-info has-text-centered">
                    <span class="icon">
                        <i class="fas fa-info-circle"></i>
                    </span>

                    <span>{{ translate("pricing.no_existing_p24_configs") }}</span>
                </Notification>
            </div>
        </div>
        <LoadingSpinner2 v-else class="has-added-margin" />
    </div>
</template>

<script setup lang="ts">
    import { ref, computed, onMounted } from "vue";
    import Notification from "../../Common/Notification.vue";
    import LoadingSpinner2 from "../../Common/LoadingSpinner2.vue";
    import { translate } from "../../Common/translations";
    import { handleError } from "../../Common/errorHandler";
    import paymentGatewayConfigApi, { ExistingPaymentGatewayConfig } from "../../Api/paymentGatewayConfig";
    import { usePaymentGatewayConfigStore, usePricingSetupStore } from "../pricingSetupApp";

    const store = usePricingSetupStore();
    const paymentGatewayConfigStore = usePaymentGatewayConfigStore();

    const initDone = ref(false);
    const paymentGatewayConfigs = ref<ExistingPaymentGatewayConfig[]>([]);
    const selectedExistingConfigurationId = ref<string>("0");

    const userId = computed(() => store.userId);

    const canChooseExistingConfig = computed(() => selectedExistingConfigurationId.value !== "0");

    const confirmExistingConfiguration = () => {
        const config = paymentGatewayConfigs.value.find(c => c.id === selectedExistingConfigurationId.value);
        if (!config) {
            return;
        }

        paymentGatewayConfigStore.chosenConfig = config;
        paymentGatewayConfigStore.view = "general_configuration";
    };

    onMounted(() => {
        initDone.value = false;
        return paymentGatewayConfigApi
            .getConfigListingForUser(userId.value)
            .then(configs => (paymentGatewayConfigs.value = configs))
            .catch(handleError)
            .finally(() => {
                initDone.value = true;
            });
    });
</script>

<style scoped></style>
